(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["terraflex-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('terraflex-size-guide')) {
    class TerraFlexSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-guide-open]');
        this.tabs = Array.from(this.querySelectorAll('[data-guide-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-guide-panel]'));
        this.trigger.addEventListener('click', () => {
          this.activate(this.dataset.defaultGroup);
          this.dialog.showModal();
          this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true').focus();
        }, options);
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.trigger.focus({ preventScroll: true }), options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.guideTab), options);
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.activate(this.tabs[next].dataset.guideTab);
            this.tabs[next].focus();
          }, options);
        });
      }
      activate(group) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.guideTab === group;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.guidePanel !== group; });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
      }
    }
    customElements.define('terraflex-size-guide', TerraFlexSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["terraflex-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('terraflex-videos')) {
    customElements.define('terraflex-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.videos = [...this.querySelectorAll('video')];
        this.toggle = this.querySelector('button');
        this.lazyLoading = this.hasAttribute('data-lazy');
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motionPreference.matches || (this.lazyLoading && navigator.connection?.saveData === true);
        this.visible = false;
        this.videos.forEach(video => { video.muted = true; video.controls = false; });
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncPlayback();
        }, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal: this.controller.signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting && (!this.lazyLoading || entry.intersectionRatio >= 0.15));
          this.syncPlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        if (this.lazyLoading) {
          this.loadObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting) && !this.userPaused) this.loadSources();
          }, { rootMargin: '100px 0px', threshold: 0 });
          this.loadObserver.observe(this);
          this.motionPreference.addEventListener('change', event => {
            if (event.matches) {
              this.userPaused = true;
              this.syncPlayback();
            }
          }, { signal: this.controller.signal });
        }
        this.updateButton();
      }
      loadSources() {
        if (!this.lazyLoading || this.sourcesLoaded) return;
        this.sourcesLoaded = true;
        this.videos.forEach(video => {
          video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
            delete source.dataset.src;
          });
          video.preload = 'metadata';
          video.load();
        });
        this.loadObserver?.disconnect();
      }
      updateButton() {
        const playing = !this.userPaused && this.visible && !document.hidden;
        this.toggle.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.toggle.setAttribute('aria-label', this.toggle.textContent);
      }
      syncPlayback() {
        const shouldPlay = this.visible && !this.userPaused && !document.hidden;
        if (shouldPlay) this.loadSources();
        this.videos.forEach(video => {
          if (shouldPlay) {
            video.play().catch(error => {
              if (this.lazyLoading && error.name === 'AbortError') return;
              this.userPaused = true;
              this.videos.forEach(item => item.pause());
              this.updateButton();
            });
          } else {
            video.pause();
          }
        });
        this.updateButton();
      }
      disconnectedCallback() {
        this.videos?.forEach(video => video.pause());
        this.observer?.disconnect();
        this.loadObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
